import { makeGetRequest, makePutRequest } from 'lib/axios';
import { BagelPrompt } from '../types';

export async function listBagelPrompts(): Promise<BagelPrompt[]> {
  const res = await makeGetRequest<{
    message: string;
    payload: BagelPrompt[];
  }>('/bagel/prompts');
  return res.data.payload;
}

export async function getBagelPrompt(name: string): Promise<BagelPrompt> {
  const res = await makeGetRequest<{
    message: string;
    payload: BagelPrompt;
  }>(`/bagel/prompts/${name}`);
  return res.data.payload;
}

export async function updateBagelPrompt(
  name: string,
  content: string,
  description?: string,
): Promise<BagelPrompt> {
  const res = await makePutRequest<{
    message: string;
    payload: BagelPrompt;
  }>(`/bagel/prompts/${name}`, { content, description });
  return res.data.payload;
}
